import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import { QuizProvider, useQuiz } from "./context/QuizContext";
import { Quiz } from "./components/Quiz";
import { Banner, Header, Footer, CookieConsent } from "./components/Layout";
import { CartDrawer } from "./components/CartDrawer";
import Home from "./pages/Home";
import ProductPage from "./pages/ProductPage";
import Boutique from "./pages/Boutique";
import Science from "./pages/Science";
import Merci from "./pages/Merci";
import Legal from "./pages/Legal";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const SmoothScroll = () => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);
  return null;
};

const QuizMount = () => {
  const { open, closeQuiz } = useQuiz();
  return <Quiz open={open} onClose={closeQuiz} />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CartProvider>
          <QuizProvider>
            <SmoothScroll />
            <ScrollTop />
            <Banner />
            <Header />
            <CartDrawer />
            <QuizMount />
            <Toaster theme="dark" position="bottom-center" toastOptions={{ style: { background: "#141414", border: "1px solid #262626", color: "#F5F5F3" } }} />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/boutique" element={<Boutique />} />
              <Route path="/science" element={<Science />} />
              <Route path="/merci" element={<Merci />} />
              <Route path="/kit" element={<ProductPage id="kit" />} />
              <Route path="/pastilles" element={<ProductPage id="pastilles" />} />
              <Route path="/bain-de-bouche" element={<ProductPage id="bain-de-bouche" />} />
              <Route path="/brosse" element={<ProductPage id="brosse" />} />
              <Route path="/cgv" element={<Legal page="cgv" />} />
              <Route path="/mentions-legales" element={<Legal page="mentions" />} />
              <Route path="/confidentialite" element={<Legal page="confidentialite" />} />
              <Route path="/livraison-retours" element={<Legal page="livraison" />} />
            </Routes>
            <Footer />
            <CookieConsent />
          </QuizProvider>
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
